export const removeEmptyTemplate = (editor: Editor, useTimeout = false) => {
  const performRemoval = () => {
    const templateElements = editor.dom.select('[data-template]')
    let hasRemoved = false

    templateElements.forEach((templateElement) => {
      const isEmpty = !(templateElement?.textContent || '').trim()
      const hasSingleBreak =
        templateElement?.childNodes?.length === 1 &&
        templateElement?.firstChild?.nodeName === 'BR'
      const shouldRemove = isEmpty || hasSingleBreak
      if (shouldRemove) {
        editor.dom.remove(templateElement)
        hasRemoved = true
      }
    })

    if (hasRemoved) {
      editor.fire('change')
    }
  }

  if (useTimeout) {
    setTimeout(performRemoval, 0)
  } else {
    performRemoval()
  }
}
